import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

import { CreateNewTaskDialogComponent } from '../components/create-new-task-dialog/create-new-task-dialog.component';
import { TaskCardDialogComponent } from '../components/task-card-dialog/task-card-dialog.component';
import { TaskInterface } from '../models';
import { TaskDialogDataInterface } from '../models/task-dialog-data.model';

@Injectable()
export class TaskDialogService {
  constructor(private dialog: MatDialog) {}

  public createNewTaskDialog(dialogData: TaskDialogDataInterface): void {
    this.openCreateTaskDialog(dialogData);
  }

  public openTaskDialog(taskToOpen: TaskInterface,
                        data: TaskDialogDataInterface,
                        showCommentsInDialog?: boolean): void {
    const dialogData: any = {
      task: taskToOpen,
      showComments: showCommentsInDialog,
      isAdmin: data.isTaskAdmin,
      isSubject: taskToOpen.subject.id === data.loggedInUser.id,
      isAssignedTo: taskToOpen.assignedTo.id === data.loggedInUser.id,
    };
    this.dialog.open(TaskCardDialogComponent, {
      width: '900px',
      data: dialogData,
    });
  }

  private openCreateTaskDialog(data: TaskDialogDataInterface): void {
    const createDialogRef: MatDialogRef<CreateNewTaskDialogComponent> = this.dialog.open(CreateNewTaskDialogComponent, {
      data,
      height: '600px',
      width: '800px',
    });

    createDialogRef.afterClosed().subscribe((newTask: TaskInterface) => {
      if(!newTask) { return; }
      if(newTask.assignedTo.id === data.loggedInUser.id) {
        this.openTaskDialog(newTask, data);
      }
    });
  }
}
